// Module
var code = "<div class=\"responsive-video__wrapper\">\n  <div class=\"responsive-video__container\">\n    <div id=\"ncst-lightbox-video-player\"></div>\n  </div>\n</div>\n";
// Exports
export default code;